// extracted by css-extract-rspack-plugin
export default {"share":"style_share__lxtFp","headline":"style_headline__ThHUM","content":"style_content__mxRN2","button":"style_button__pNVHf"};